import { Injectable, Renderer2, RendererFactory2, inject } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  private rendererFactory = inject(RendererFactory2);

  private renderer: Renderer2;

  constructor() {
    this.renderer = this.rendererFactory.createRenderer(null, null);
  }

  initializeTheme(): void {
    const colorTheme = localStorage.getItem('color-theme');
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
    const uiSkinName = localStorage.getItem('uiSkinName');

    if (colorTheme === 'dark' || (!colorTheme && prefersDark)) {
      this.renderer.addClass(document.documentElement, 'dark');
    } else {
      this.renderer.removeClass(document.documentElement, 'dark');
    }

    if (uiSkinName) {
      this.renderer.setAttribute(document.documentElement, 'ui-skin', uiSkinName);
    }
  }

  getCurrentColorScheme(): 'light' | 'dark' {
    if (document.documentElement.classList.contains('dark')) {
      return 'dark';
    } else {
      return 'light';
    }
  }

  toggleColorScheme(): 'light' | 'dark' {
    if (document.documentElement.classList.contains('dark')) {
      this.renderer.removeClass(document.documentElement, 'dark');
      localStorage.setItem('color-theme', 'light');
      return 'light';
    } else {
      this.renderer.addClass(document.documentElement, 'dark');
      localStorage.setItem('color-theme', 'dark');
      return 'dark';
    }
  }
}
